import React from 'react';
import { 
  AppBar, 
  Toolbar, 
  Button, 
  Box, 
  useScrollTrigger
} from '@mui/material';

// Importe a sua Logo aqui
import HeaderLogo from '../assets/logo.png'; 

// Lista de links de navegação
const navItems = [
  { label: 'Quem Sou Eu', id: 'sobre' },
  { label: 'Serviços', id: 'servicos' },
  { label: 'Contato', id: 'contato' }
];

const Header = () => {
  // Efeito de fundo transparente no topo e sólido ao rolar
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 50,
  });

  // Função para rolar suavemente até a seção
  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
      // Desconto da altura da logo gigante para não cobrir o título da seção
      const headerOffset = 160; 
      const elementPosition = section.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <>
      <AppBar 
        position="fixed" 
        sx={{ 
          bgcolor: trigger ? 'rgba(0, 0, 0, 0.95)' : 'transparent',
          backdropFilter: trigger ? 'blur(10px)' : 'none',
          boxShadow: trigger ? '0 4px 20px rgba(0,0,0,0.5)' : 'none',
          transition: 'all 0.3s ease',
          py: 1
        }}
      >
        <Toolbar 
          sx={{ 
            display: 'flex', 
            // Mobile: Centraliza a Logo | Desktop: Alinha tudo à esquerda
            justifyContent: { xs: 'center', md: 'flex-start' }, 
            px: { xs: 2, md: 5 } 
          }}
        >
          
          {/* LOGO DA MARCA (Tamanho 3x maior) */}
          <Box 
            component="img" 
            src={HeaderLogo} 
            alt="Mario Bento Logo"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            sx={{ 
              height: { xs: 120, md: 150 }, 
              cursor: 'pointer',
              transition: 'transform 0.2s ease',
              '&:hover': { transform: 'scale(1.05)' },
              // Margem à direita apenas no desktop para afastar dos links
              mr: { xs: 0, md: 4 } 
            }} 
          />

          {/* MENU DESKTOP (Escondido no mobile, visível ao lado da logo no desktop) */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', gap: 3 }}>
            {navItems.map((item) => (
              <Button 
                key={item.id} 
                onClick={() => scrollToSection(item.id)}
                sx={{ 
                  color: 'white', 
                  fontWeight: 600,
                  fontSize: '1rem', // Tamanho de fonte um pouco mais elegante
                  '&:hover': { color: 'primary.main', bgcolor: 'transparent' }
                }}
              >
                {item.label}
              </Button>
            ))}
          </Box>

        </Toolbar>
      </AppBar>

      {/* Box vazio para evitar que o Header esconda o topo do site */}
      <Toolbar sx={{ py: { xs: 6, md: 8 } }} />
    </>
  );
};

export default Header;